import React from 'react';
import { Button, Flex, Text } from 'theme-ui';
import PlusIcon from '~/assets/images/icons/plus-rounded-corners.svg';
import useCTAStyle from '~/hooks/components/use-cta-style';
type Props = {
  handleClick: () => void;
  isTrayOpen: boolean;
};

const QuickshopButton = ({ handleClick, isTrayOpen }: Props) => {
  const CTAStyles = useCTAStyle({
    baseColor: 'Black',
    disableDisabledStyle: false,
    size: 'Medium',
    variant: 'Outline',
  });

  if (isTrayOpen) return null;

  return (
    <Flex sx={{ justifyContent: 'flex-end' }}>
      <Button
        onClick={handleClick}
        variant="bare"
        sx={{
          ...CTAStyles,
          fontSize: '1.4rem',
          lineHeight: 1.15,
          fontWeight: 500,
          pl: '1.6rem',
          pr: '0.8rem',
          height: '4rem',
          borderRadius: '3rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.8rem',
          border: '1px solid black',
          '&:hover': {
            'svg path': {
              stroke: 'white',
            },
          },
        }}
      >
        <Text>Quickshop</Text> <PlusIcon />
      </Button>
    </Flex>
  );
};

export default QuickshopButton;
